import { BaseAssetManagerContextProvider } from 'modules/assetManager/contexts/BaseAssetManagerContextProvider';
import { displayContent } from 'modules/templateEditor/common';
import { ContentEditorPreferencesProvider } from 'modules/templateEditor/context/ContentEditorPreferencesContext';
import {
  useCreateSmartOptInLink,
  useSmartOptInLinksByProjectId,
  useUpdateSmartOptInLink,
} from 'modules/templateEditor/hooks/useSmartOptInLinks';
import { validateSmartLink } from 'modules/templateEditor/modals/SmsSmartOptInModal/SmsSmartOptInModal.utils';
import { SmsSmartOptInProvider } from 'modules/templateEditor/modals/SmsSmartOptInModal/contexts/SmsSmartOptInProvider';
import { EmailPreviewContextProvider } from '../context/EmailPreviewContextProvider';

export const EditEmailContext = ({ children }: { children: React.ReactNode }) => (
  <ContentEditorPreferencesProvider>
    <EmailPreviewContextProvider>
      <BaseAssetManagerContextProvider
        assetSource={useSmartOptInLinksByProjectId}
        assetTypeName={displayContent.strSmsSmartOptInAssetTypeName}
        createAssetHook={useCreateSmartOptInLink}
        updateAssetHook={useUpdateSmartOptInLink}
        validateAsset={validateSmartLink}
      >
        <SmsSmartOptInProvider>{children}</SmsSmartOptInProvider>
      </BaseAssetManagerContextProvider>
    </EmailPreviewContextProvider>
  </ContentEditorPreferencesProvider>
);
